import { FormBox, HelperBox, TextField, Typography, useFormBaseContext } from "@foodpilot/foods";
import Box from "@mui/material/Box";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PackagingFormType } from "../../PackagingForm.types";

type Page1Props = {
    packaging: PackagingFormType;
    setPackaging: (newPackaging: PackagingFormType) => void;
};
const Page1 = (props: Page1Props) => {
    return (
        <Box
            sx={{
                display: "flex",
                gap: "1rem",
            }}
        >
            <FormBox sx={{ flex: 1 }}>
                <BaseInformation {...props} />
            </FormBox>
        </Box>
    );
};
export default Page1;

const BaseInformation = (props: Page1Props) => {
    const { packaging, setPackaging } = props;
    const { t } = useTranslation();
    const { lockForward, unlockForward } = useFormBaseContext();

    const isNameValid = (name: string | null) => {
        return name && name.trim().length > 0;
    };

    useEffect(() => {
        const isPageError = !isNameValid(packaging.name);

        if (isPageError) {
            const errorMessage = t("form.invalidStep");
            lockForward(errorMessage);
            return;
        }
        unlockForward();
    }, [packaging.name]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "50px",
            }}
        >
            <TextField
                title={t("packagings.name")}
                required={true}
                error={!isNameValid(packaging.name)}
                placeholder={""}
                value={packaging.name ?? ""}
                onChange={(e) => {
                    const newName = e.target.value;
                    setPackaging({
                        ...packaging,
                        name: newName,
                    });
                }}
            />
            <Box>
                <TextField
                    title={t("unique_identifier")}
                    placeholder={""}
                    value={packaging.externalId ?? ""}
                    onChange={(e) => {
                        const newExternalId = e.target.value;
                        setPackaging({
                            ...packaging,
                            externalId: newExternalId,
                        });
                    }}
                />
                <HelperBox>
                    <Typography variant="body">
                        {t(
                            "L'identifiant unique correspond à la manière dont vous marquer vos ingrédients dans votre entreprise",
                        )}
                    </Typography>
                </HelperBox>
            </Box>
            <Box>
                <Typography variant="body">{t("form.mandatory-field")}</Typography>
            </Box>
        </div>
    );
};
